// Единый хелпер копирования в буфер обмена (SSoT/SRP).
// WebView2 (desktop): navigator.clipboard может быть недоступен (не secure
// context / нет разрешения) — НЕ полагаемся только на него. Fallback:
// document.execCommand('copy') через скрытый textarea (работает в WebView2
// надёжно, синхронно). Ошибка БРОСАЕТСЯ — вызывающий показывает.

export async function copyToClipboard(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // fallback ниже
    }
  }
  legacyCopy(text);
}

function legacyCopy(text: string): void {
  const ta = document.createElement('textarea');
  ta.value = text;
  // Вне экрана (не визуально) — иначе скачет скролл
  ta.style.position = 'fixed';
  ta.style.top = '-1000px';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  if (!ok) {
    throw new Error('Не удалось скопировать: буфер обмена недоступен');
  }
}
